import { Breadcrumb, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { formatUcWords } from "../helpers/format";
import useBreadcrumbs from "../hooks/useBreadcrumbs";

const Breadcrumbs: React.FC = () => {
	const { breadcrumb: breadcrumbReplacer } = useBreadcrumbs();
	const breadcrumbs = useReactRouterBreadcrumbs();
	const history = useHistory();

	const renderLabel = (label: any) => {
		let find = breadcrumbReplacer.find(
			(item) => item.origin?.toLowerCase() === label?.props?.children?.toLowerCase()
		);
		if (find) {
			return (find.label?.length ?? 0) > 20 ? find?.label?.substring(0, 20) + "..." : find.label;
		}
		const labels = label.props.children.split("-");
		if (labels.length > 0) {
			const newLabel = labels.join(" ").toString();
			return formatUcWords(newLabel.length > 20 ? newLabel.substring(0, 20) + "..." : newLabel);
		} else {
			return formatUcWords(label.props.children);
		}
	};

	const handleBreadcrumb = (e: any, link: string, locationState: any) => {
		e.preventDefault();

		history.push({
			pathname: link,
			state: {
				...locationState,
			},
		});
	};

	console.log("breadcrums", breadcrumbs.slice(1));

	return (
		<Breadcrumb
			separator={
				<img
					src="/images/breadcrumb-separator.svg"
					alt="breadcrumb-separator"
					width="5"
				/>
			}
		>
			{breadcrumbs.slice(1).map(({ breadcrumb, match, location }, index) => (
				<Breadcrumb.Item key={match.url}>
					<div
						key={index}
						onClick={(e) => handleBreadcrumb(e, match.url, location.state)}
					>
						<Typography.Text
							strong
							style={{
								fontSize: 16,
								color: "#fff",
							}}
						>
							{renderLabel(breadcrumb)}
						</Typography.Text>
					</div>
				</Breadcrumb.Item>
			))}
		</Breadcrumb>
	);
};

export default Breadcrumbs;
